export const results = [
  {
    id: 1,
    caseName: 'Партнёрство и инновации',
    teams: [
      {
        place: 1,
        name: 'Со-проектирование ТОП IT-образования на транспорте',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '34',
      },
      {
        place: 2,
        name: 'Партнерство, которое работает',
        university: 'ГМУ им. адм. Ф.Ф. Ушакова',
        status: 'finalist',
        score: '32,67',
      },
      {
        place: 3,
        name: 'Персонализированная отраслевая траектория ЖАТ',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '32',
      },
      {
        place: 4,
        name: 'Аккредитация "на отлично"',
        university: 'ГМУ им. адм. Ф.Ф. Ушакова',
        status: 'finalist',
        score: '30,5',
      },
      {
        place: 5,
        name: '"Море Возможностей" и "Школа юного моряка"',
        university: 'МГУ им. адм. Г.И. Невельского',
        status: 'finalist',
        score: '29,67',
      },
      {
        place: 6,
        name: 'Цифровой фарватер: путь в профессию речника',
        university: 'ИМРФ им. ГСС М.П. Девятаева – Казанский филиал ВГУВТ',
        status: 'finalist',
        score: '29,5',
      },
      {
        place: 7,
        name: 'Цифровая экосистема инноваций на транспорте',
        university: 'ПривГУПС',
        status: 'finalist',
        score: '28,34',
      },
      {
        place: 8,
        name: 'Школа, ВУЗ, лаборатория: научное партнерство',
        university: 'ГМУ им. адм. Ф.Ф. Ушакова',
        status: 'finalist',
        score: '28,17',
      },
      {
        place: 9,
        name: 'Employer-to-Classroom: «Курс на максимум»',
        university: 'ГУМРФ им. адм. С.О. Макарова',
        status: 'finalist',
        score: '28',
      },
      {
        place: 10,
        name: 'Научно ближе, чем кажется! СНК: старт и рост.',
        university: 'ПГУПС',
        status: 'finalist',
        score: '27,67',
      },
    ],
  },
  {
    id: 2,
    caseName: 'Педагогический приём',
    teams: [
      {
        place: 1,
        name: 'Карта доказательств: историческая реконструкция по',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '28,5',
      },
      {
        place: 2,
        name: 'Лаборатория критических сценариев',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '28',
      },
      {
        place: 3,
        name: 'Метакогнитивный чек-лист',
        university: 'ДВГУПС',
        status: 'finalist',
        score: '28',
      },
      {
        place: 4,
        name: 'Формирование правовой культуры моряков',
        university: 'ГМУ им. адм. Ф.Ф. Ушакова',
        status: 'finalist',
        score: '28',
      },
      {
        place: 5,
        name: '«Инструкция под проверкой»: игровой педагогический',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '28',
      },
      {
        place: 6,
        name: 'Диспетчерский круг',
        university: 'ПривГУПС',
        status: 'finalist',
        score: '27,5',
      },
      {
        place: 7,
        name: 'Морской прецедент',
        university: 'ИВТ им. Г.Я. Седова – Филиал ГМУ им. адм. Ф.Ф. Ушакова',
        status: 'finalist',
        score: '27,5',
      },
      {
        place: 8,
        name: '«Проектное решение: от гипотезы к выбору"',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '27',
      },
      {
        place: 9,
        name: 'ЛИФТ В ТЕХНО ЛИДЕРЫ ЧЕРЕЗ НАСТАВНИЧЕСТВО',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '27',
      },
      {
        place: 10,
        name: 'Неотсроченная трёхэтапная обратная связь на лекции',
        university: 'ПримИЖТ – Филиал ДВГУПС в г. Уссурийске',
        status: 'finalist',
        score: '27',
      },
    ],
  },
  {
    id: 3,
    caseName: 'Территория роста',
    teams: [
      {
        place: 1,
        name: 'Всероссийский креативный молодежный лагерь "ШАНС"',
        university: 'ПривГУПС',
        status: 'finalist',
        score: '30,5',
      },
      {
        place: 2,
        name: 'Студенческий медиацентр «Колея» РУТ (МИИТ)',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '30,5',
      },
      {
        place: 3,
        name: 'Российско-Китайский студенческий разговорный клуб',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '29,5',
      },
      {
        place: 4,
        name: 'Поможем въехать!',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '29',
      },
      {
        place: 5,
        name: 'Посткроссинг: мост между людьми и поколениями',
        university: 'ОмГУПС (ОмИИТ)',
        status: 'finalist',
        score: '29',
      },
      {
        place: 6,
        name: 'Детская академия транспорта',
        university: 'ПривГУПС',
        status: 'finalist',
        score: '28',
      },
      {
        place: 7,
        name: 'Конкурс ИТ-проектов «Цифровой норд-ост»',
        university: 'ГМУ им. адм. Ф.Ф. Ушакова',
        status: 'finalist',
        score: '28',
      },
      {
        place: 8,
        name: 'Проектная экосистема Цифровой кафедры',
        university: 'ПГУПС',
        status: 'finalist',
        score: '28',
      },
      {
        place: 9,
        name: 'Интеллект-транзит',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '27,5',
      },
      {
        place: 10,
        name: 'Живая модель: ассемблирование языка и инженерии',
        university: 'СГУПС',
        status: 'finalist',
        score: '27',
      },
      {
        place: 11,
        name: 'Маршрут будущего',
        university: 'ПривГУПС',
        status: 'finalist',
        score: '27',
      },
    ],
  },
  {
    id: 4,
    caseName: 'Цифровой педагог',
    teams: [
      {
        place: 1,
        name: 'Цифровой полигон «Радиосвязь в условиях ВСМ»',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '28',
      },
      {
        place: 2,
        name: 'Организация доступной среды на транспорте',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '28',
      },
      {
        place: 3,
        name: 'VR Shift: от риска к культуре электробезопасности.',
        university: 'УрГУПС',
        status: 'finalist',
        score: '27',
      },
      {
        place: 4,
        name: 'Цифровая экосистема преподавателя СПО.',
        university: 'КИМРТ им. ген.-адм. Ф.М. Апраксина – Филиал ВГУВТ',
        status: 'finalist',
        score: '27',
      },
      {
        place: 5,
        name: 'NAVSIM: Симулятор Аварийного Радиообмена в Море',
        university: 'СГУВТ',
        status: 'finalist',
        score: '26,5',
      },
      {
        place: 6,
        name: 'Мобильный педагог',
        university: 'ГУМРФ им. адм. С.О. Макарова',
        status: 'finalist',
        score: '26,5',
      },
      {
        place: 7,
        name: 'VR-СИМУЛЯТОР ТРАНСПОРТНО-ЛОГИСТИЧЕСКИХ КОМПЛЕКСОВ',
        university: 'КрИЖТ – Филиал ИрГУПС',
        status: 'finalist',
        score: '26',
      },
      {
        place: 8,
        name: 'Курс «4К-навыки в гибридной ИИ-среде»',
        university: 'ДВГУПС',
        status: 'finalist',
        score: '26',
      },
      {
        place: 9,
        name: 'Проектирование и расчеты ВСП',
        university: 'РУТ (МИИТ)',
        status: 'finalist',
        score: '26',
      },
    ],
  },
];
